<template>
  <div class="brand-manage-container">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="品牌管理" name="brands">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ $t('brandManage.title') }}</span>
            <el-button type="primary" @click="handleAddBrand" class="pull-right">
              {{ $t('brandManage.addBrand') }}
            </el-button>
          </div>
      <el-form :inline="true" :model="brandManageInfo.searchForm" class="demo-form-inline">
        <el-form-item :label="$t('brandManage.brandName')">
          <el-input v-model="brandManageInfo.searchForm.brandName" :placeholder="$t('brandManage.brandNamePlaceholder')" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">{{ $t('common.search') }}</el-button>
          <el-button @click="handleReset">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="brandManageInfo.brands" border style="width: 100%">
        <el-table-column type="index" :label="$t('common.index')" width="80" />
        <el-table-column prop="communityName" :label="$t('brandManage.communityName')" />
        <el-table-column prop="brandName" :label="$t('brandManage.brandName')" />
        <el-table-column prop="brandDesc" :label="$t('brandManage.brandDesc')" />
        <el-table-column prop="phone" :label="$t('brandManage.phone')" />
        <el-table-column prop="sort" :label="$t('brandManage.sort')" />
        <el-table-column prop="brandLogoUrl" :label="$t('brandManage.brandLogo')">
          <template slot-scope="scope">
            <img v-if="scope.row.brandLogoUrl" :src="scope.row.brandLogoUrl" style="width: 50px; height: 50px; object-fit: cover" />
            <span v-else>{{ $t('common.noData') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('brandManage.state')" />
        <el-table-column :label="$t('common.action')" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="handleEditBrand(scope.row)">
              {{ $t('common.edit') }}
            </el-button>
            <el-button type="danger" size="small" @click="handleDeleteBrand(scope.row)">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="brandManageInfo.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="brandManageInfo.row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="brandManageInfo.total"
        class="pagination"
      />
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="品牌评价" name="evaluations">
        <brand-evaluation />
      </el-tab-pane>
    </el-tabs>
    <add-brand ref="addBrand" @success="handleBrandSuccess" />
  </div>
</template>

<script>
import AddBrand from '@/components/shop/addBrand'
import BrandEvaluation from '@/components/shop/brandEvaluation'
import { listBrands, deleteBrand } from '@/api/shop/brandApi'
import { getCommunityId, _loadCommunityInfo } from '@/api/community/communityApi'

export default {
  name: 'BrandManageList',
  components: {
    AddBrand,
    BrandEvaluation
  },
  data() {
    return {
      activeTab: 'brands',
      brandManageInfo: {
        searchForm: {
          brandName: ''
        },
        brands: [],
        page: 1,
        row: 10,
        total: 0
      },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    console.log('Initial communityId:', this.communityId)
    this.loadBrands()
  },
  methods: {
    async loadBrands() {
      try {
        console.log('=== Starting to load brands ===')
        // 检查小区 ID 是否有效
        console.log('Current communityId:', this.communityId)
        if (this.communityId === '-1' || !this.communityId) {
          // 加载小区信息
          console.log('Loading community info...')
          try {
            const communityResponse = await _loadCommunityInfo()
            console.log('Community info loaded:', communityResponse)
          } catch (communityError) {
            console.error('Failed to load community info:', communityError)
          }
          this.communityId = getCommunityId()
          console.log('Updated communityId:', this.communityId)
        }
        
        const params = {
          page: this.brandManageInfo.page,
          row: this.brandManageInfo.row,
          brandName: this.brandManageInfo.searchForm.brandName
        }
        // 只有当 communityId 不是 -1 时才传递，避免查询条件错误
        if (this.communityId !== '-1' && this.communityId) {
          params.communityId = this.communityId
        }
        console.log('Loading brands with params:', params)
        console.log('API URL:', '/app/brand.listBrands')
        const response = await listBrands(params)
        console.log('Brand list response:', response)
        console.log('Response type:', typeof response)
        console.log('Response keys:', Object.keys(response))
        
        // 检查响应数据结构
        // axios 响应的 data 字段才是 API 返回的实际数据
        const apiResponse = response.data
        console.log('API response data:', apiResponse)
        
        if (apiResponse.code === 0) {
          console.log('API returned success')
          console.log('Data:', apiResponse.data)
          console.log('Total:', apiResponse.total)
          
          // 检查每个品牌的员工数据
          apiResponse.data.forEach((brand, index) => {
            console.log(`Brand ${index} employees:`, brand.employees)
            console.log(`Brand ${index} has employees:`, brand.employees && brand.employees.length > 0)
          })
          
          const { data, total } = apiResponse
          // 转换状态码为状态名称
          const brandsWithStateName = data.map(brand => {
            return {
              ...brand,
              stateName: brand.state === '1001' ? this.$t('brandManage.stateOff') : this.$t('brandManage.stateOn'),
              // 构建完整的 logo URL
              brandLogoUrl: brand.brandLogo ? this.getBrandLogoUrl(brand.brandLogo, brand.communityId) : '',
              // 保留员工信息
              employees: brand.employees || []
            }
          })
          console.log('Brands with state name:', brandsWithStateName)
          console.log('Processed brands:', brandsWithStateName)
          this.brandManageInfo.brands = brandsWithStateName
          this.brandManageInfo.total = total
        } else {
          console.error('API returned error:', apiResponse.msg)
          this.$message.error(apiResponse.msg || this.$t('brandManage.loadFailed'))
        }
      } catch (error) {
        console.error('Failed to load brands:', error)
        console.error('Error message:', error.message)
        console.error('Error stack:', error.stack)
        this.$message.error(this.$t('brandManage.loadFailed'))
      } finally {
        console.log('=== Finished loading brands ===')
      }
    },
    handleSearch() {
      this.brandManageInfo.page = 1
      this.loadBrands()
    },
    handleReset() {
      this.brandManageInfo.searchForm = {
        brandName: ''
      }
      this.brandManageInfo.page = 1
      this.loadBrands()
    },
    handleSizeChange(size) {
      this.brandManageInfo.row = size
      this.loadBrands()
    },
    handleCurrentChange(current) {
      this.brandManageInfo.page = current
      this.loadBrands()
    },
    handleAddBrand() {
      this.$refs.addBrand.show()
    },
    handleEditBrand(row) {
      this.$refs.addBrand.show(row)
    },
    async handleDeleteBrand(row) {
      try {
        await this.$confirm(this.$t('brandManage.deleteConfirm'), this.$t('common.confirm'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        })
        const response = await deleteBrand(row.brandId)
        // axios 响应的 data 字段才是 API 返回的实际数据
        const apiResponse = response.data
        if (apiResponse.code === 0) {
          this.$message.success(this.$t('common.deleteSuccess'))
          this.loadBrands()
        } else {
          this.$message.error(apiResponse.msg)
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Failed to delete brand:', error)
          this.$message.error(this.$t('brandManage.deleteFailed'))
        }
      }
    },
    handleBrandSuccess() {
      this.loadBrands()
    },
    getBrandLogoUrl(brandLogo, communityId) {
      if (!brandLogo) return ''
      // 检查brandLogo是否已经是完整URL
      if (brandLogo.startsWith('http://') || brandLogo.startsWith('https://')) {
        return brandLogo
      }
      // 检查brandLogo是否已经包含下载路径
      if (brandLogo.includes('callComponent/download/getFile')) {
        return brandLogo
      }
      // 处理包含callComponent/resource/getResource的情况，提取fileId参数
      if (brandLogo.includes('callComponent/resource/getResource')) {
        const fileIdMatch = brandLogo.match(/fileId=([^&]+)/)
        if (fileIdMatch && fileIdMatch[1]) {
          return `/callComponent/download/getFile/file?fileId=${fileIdMatch[1]}&communityId=${communityId || this.communityId}`
        }
      }
      // 构建完整的logo URL
      return `/callComponent/download/getFile/file?fileId=${brandLogo}&communityId=${communityId || this.communityId}`
    }
  }
}
</script>

<style lang="scss" scoped>
.brand-manage-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .pagination {
    margin-top: 20px;
    text-align: right;
  }

  .pull-right {
    float: right;
  }
}
</style>